import { cn } from "@newxsystems/shared";
import { TootMegaMenu } from "../../../../modules/interactive/components/TootMegaMenu/TootMegaMenu";
import type { IMegaMenuBlockProps } from "./MegaMenuBlock.props";

export const MegaMenuBlock = ({ actions, items, logo, parentClass }: IMegaMenuBlockProps) => {
  if (!logo && !items?.length && !actions?.length) {
    return null;
  }

  return (
    <section className={cn("relative z-50 overflow-visible py-3 md:py-4", parentClass)}>
      <div className="toot-container relative z-50 overflow-visible">
        <TootMegaMenu actions={actions} items={items} logo={logo} />
      </div>
    </section>
  );
};

MegaMenuBlock.displayName = "Block::MegaMenuBlock";
